/**
 * Centralized lazy loader for LeCoffreApi factory getters.
 * Single place for dynamic require() to avoid no-require-imports bypass in every API module.
 * Used for compatibility with Webpack/Next (lazy init, avoid TDZ).
 * Rule @typescript-eslint/no-require-imports is relaxed for this file only in eslint.config.mjs.
 */

const cache: Record<string, () => unknown> = {};

const loaders: Record<string, () => () => unknown> = {
	"LeCoffreApi/Notary/SearchOffices": () =>
		require("../LeCoffreApi/Notary/SearchOffices/SearchOfficesFactory").getSearchOfficesInstance,
	"LeCoffreApi/Notary/Customers": () =>
		require("../LeCoffreApi/Notary/Customers/CustomersFactory").getCustomersInstance,
	"LeCoffreApi/Notary/FolderThirdParties": () =>
		require("../LeCoffreApi/Notary/FolderThirdParties/FolderThirdPartiesFactory").getFolderThirdPartiesInstance,
	"LeCoffreApi/Notary/DeedTypes": () =>
		require("../LeCoffreApi/Notary/DeedTypes/DeedTypesFactory").getDeedTypesInstance,
	"LeCoffreApi/Notary/SearchNotaries": () =>
		require("../LeCoffreApi/Notary/SearchNotaries/SearchNotariesFactory").getSearchNotariesInstance,
	"LeCoffreApi/Notary/FolderSharing": () =>
		require("../LeCoffreApi/Notary/FolderSharing/FolderSharingFactory").getFolderSharingInstance,
	"LeCoffreApi/Customer/FilesNotary": () =>
		require("../LeCoffreApi/Customer/FilesNotary/FilesFactory").getFilesNotaryInstance,
	"LeCoffreApi/Notary/DocumentsNotary": () =>
		require("../LeCoffreApi/Notary/DocumentsNotary/DocumentsNotaryFactory").getDocumentsNotaryInstance,
	"LeCoffreApi/Notary/Documents": () =>
		require("../LeCoffreApi/Notary/Documents/DocumentsFactory").getDocumentsInstance,
	"Auth/Customer": () => require("../Auth/Customer/AuthFactory").getAuthInstance,
	"LeCoffreApi/ThirdParty/Documents": () =>
		require("../LeCoffreApi/ThirdParty/Documents/DocumentsFactory").getThirdPartyDocumentsInstance,
	"LeCoffreApi/SuperAdmin/SiteTexts": () =>
		require("../LeCoffreApi/SuperAdmin/SiteTexts/SiteTextsFactory").getSiteTextsAdminApiInstance,
	"LeCoffreApi/SuperAdmin/Users": () =>
		require("../LeCoffreApi/SuperAdmin/Users/UsersFactory").getUsersInstance,
	"LeCoffreApi/Public/SiteTexts": () =>
		require("../LeCoffreApi/Public/SiteTexts/SiteTextsFactory").getSiteTextsInstance,
	"LeCoffreApi/Public/IncidentReport": () =>
		require("../LeCoffreApi/Public/IncidentReport/IncidentReportFactory").getIncidentReportInstance,
	"LeCoffreApi/Notary/OfficeFolderAnchors": () =>
		require("../LeCoffreApi/Notary/OfficeFolderAnchors/OfficeFolderAnchorsFactory").getOfficeFolderAnchorsInstance,
	"LeCoffreApi/Notary/Users": () =>
		require("../LeCoffreApi/Notary/Users/UsersFactory").getUsersInstance,
	"LeCoffreApi/Notary/OfficeRoles": () =>
		require("../LeCoffreApi/Notary/OfficeRoles/OfficeRolesFactory").getOfficeRolesInstance,
	"LeCoffreApi/Notary/UserOffices": () =>
		require("../LeCoffreApi/Notary/UserOffices/UserOfficesFactory").getUserOfficesInstance,
	"LeCoffreApi/SuperAdmin/DocumentTypes": () =>
		require("../LeCoffreApi/SuperAdmin/DocumentTypes/DocumentTypesFactory").getDocumentTypesInstance,
	"LeCoffreApi/SuperAdmin/Offices": () =>
		require("../LeCoffreApi/SuperAdmin/Offices/OfficesFactory").getOfficesInstance,
	"LeCoffreApi/Notary/Files": () =>
		require("../LeCoffreApi/Notary/Files/FilesFactory").getFilesInstance,
	"LeCoffreApi/Notary/Folders": () =>
		require("../LeCoffreApi/Notary/Folders/FoldersFactory").getFoldersInstance,
	"LeCoffreApi/Notary/Notifications": () =>
		require("../LeCoffreApi/Notary/Notifications/NotificationsFactory").getNotificationsInstance,
	"LeCoffreApi/SuperAdmin/LiveVotes": () =>
		require("../LeCoffreApi/SuperAdmin/LiveVotes/LiveVotesFactory").getLiveVotesInstance,
	"LeCoffreApi/Notary/Offices": () =>
		require("../LeCoffreApi/Notary/Offices/OfficesFactory").getOfficesInstance,
	"LeCoffreApi/SuperAdmin/Health": () =>
		require("../LeCoffreApi/SuperAdmin/Health/HealthFactory").getHealthInstance,
	"LeCoffreApi/Notary/Mailchimp": () =>
		require("../LeCoffreApi/Notary/Mailchimp/MailchimpFactory").getMailchimpInstance,
	"LeCoffreApi/SuperAdmin/Customers": () =>
		require("../LeCoffreApi/SuperAdmin/Customers/CustomersFactory").getCustomersInstance,
	"LeCoffreApi/SuperAdmin/Files": () =>
		require("../LeCoffreApi/SuperAdmin/Files/FilesFactory").getFilesInstance,
	"LeCoffreApi/SuperAdmin/Folders": () =>
		require("../LeCoffreApi/SuperAdmin/Folders/FoldersFactory").getFoldersInstance,
	"LeCoffreApi/SuperAdmin/Documents": () =>
		require("../LeCoffreApi/SuperAdmin/Documents/DocumentsFactory").getDocumentsInstance,
	"LeCoffreApi/SuperAdmin/DeedTypes": () =>
		require("../LeCoffreApi/SuperAdmin/DeedTypes/DeedTypesFactory").getDeedTypesInstance,
	"LeCoffreApi/SuperAdmin/Deeds": () =>
		require("../LeCoffreApi/SuperAdmin/Deeds/DeedsFactory").getDeedsInstance,
	"LeCoffreApi/Admin/OfficeRoles": () =>
		require("../LeCoffreApi/Admin/OfficeRoles/OfficeRolesFactory").getOfficeRolesInstance,
	"LeCoffreApi/Admin/Rules": () =>
		require("../LeCoffreApi/Admin/Rules/RulesFactory").getRulesInstance,
	"LeCoffreApi/Admin/Subscriptions": () =>
		require("../LeCoffreApi/Admin/Subscriptions/SubscriptionsFactory").getSubscriptionsInstance,
	"LeCoffreApi/Admin/Documents": () =>
		require("../LeCoffreApi/Admin/Documents/DocumentsFactory").getDocumentsInstance,
	"LeCoffreApi/Admin/DeedTypes": () =>
		require("../LeCoffreApi/Admin/DeedTypes/DeedTypesFactory").getDeedTypesInstance,
	"LeCoffreApi/Admin/DocumentTypes": () =>
		require("../LeCoffreApi/Admin/DocumentTypes/DocumentTypesFactory").getDocumentTypesInstance,
	"LeCoffreApi/Customer/OfficeRib": () =>
		require("../LeCoffreApi/Customer/OfficeRib/OfficeRibFactory").getOfficeRibInstance,
	"LeCoffreApi/Customer/Folders": () =>
		require("../LeCoffreApi/Customer/Folders/FoldersFactory").getFoldersInstance,
	"LeCoffreApi/Customer/Files": () =>
		require("../LeCoffreApi/Customer/Files/FilesFactory").getFilesInstance,
	"LeCoffreApi/Customer/DocumentsNotary": () =>
		require("../LeCoffreApi/Customer/DocumentsNotary/DocumentsNotaryFactory").getDocumentsNotaryInstance,
	"LeCoffreApi/Admin/Users": () =>
		require("../LeCoffreApi/Admin/Users/UsersFactory").getUsersInstance,
	"LeCoffreApi/Admin/Deeds": () =>
		require("../LeCoffreApi/Admin/Deeds/DeedsFactory").getDeedsInstance,
	"LeCoffreApi/Notary/DocumentAnchors": () =>
		require("../LeCoffreApi/Notary/DocumentAnchors/DocumentAnchorsFactory").getDocumentAnchorsInstance,
	"LeCoffreApi/Admin/RulesGroups": () =>
		require("../LeCoffreApi/Admin/RulesGroups/RulesGroupsFactory").getRulesGroupsInstance,
	"LeCoffreApi/Notary/DocumentRemindersHistory": () =>
		require("../LeCoffreApi/Notary/DocumentRemindersHistory/DocumentRemindersHistoryFactory").getDocumentRemindersHistoryInstance,
	"LeCoffreApi/Admin/Stripe": () =>
		require("../LeCoffreApi/Admin/Stripe/StripeFactory").getStripeInstance,
	"LeCoffreApi/Admin/Roles": () =>
		require("../LeCoffreApi/Admin/Roles/RolesFactory").getRolesInstance,
	"LeCoffreApi/Customer/Documents": () =>
		require("../LeCoffreApi/Customer/Documents/DocumentsFactory").getDocumentsInstance,
	"LeCoffreApi/Notary/DocumentReminders": () =>
		require("../LeCoffreApi/Notary/DocumentReminders/DocumentRemindersFactory").getDocumentRemindersInstance,
	"LeCoffreApi/Customer/Notes": () =>
		require("../LeCoffreApi/Customer/Notes/NotesFactory").getNotesInstance,
	"LeCoffreApi/Notary/DocumentTypes": () =>
		require("../LeCoffreApi/Notary/DocumentTypes/DocumentTypesFactory").getDocumentTypesInstance,
	"LeCoffreApi/Notary/Deeds": () =>
		require("../LeCoffreApi/Notary/Deeds/DeedsFactory").getDeedsInstance,
	"LeCoffreApi/Notary/FilesNotary": () =>
		require("../LeCoffreApi/Notary/FilesNotary/FilesFactory").getFilesNotaryInstance,
	"Auth/IdNot": () => require("../Auth/IdNot/AuthFactory").getAuthInstance,
	"Auth/IdNot/User": () => require("../Auth/IdNot/UserFactory").getUserInstance,
};

export function getLazyFactoryGetter(key: string): () => unknown {
	if (!(key in cache)) {
		const loader = loaders[key];
		if (!loader) {
			throw new Error(`Unknown factory key: ${key}`);
		}
		cache[key] = loader();
	}
	return cache[key] as () => unknown;
}
